import { NOT_PERMITTED_SCREEN } from 'config/config';
import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import {
  NotPermittedScreenContainer,
  NotPermittedScreenIcon,
  NotPermittedScreenMessage,
  NotPermittedScreenStatusText,
  NotPermittedScreenWrapper,
} from './NotPermittedScreen.styles';

const { statusText, icon, description } = NOT_PERMITTED_SCREEN;

const NotPermittedScreen = memo(() => (
  <NotPermittedScreenContainer className="not-permitted-screen__container">
    <NotPermittedScreenWrapper>
      <NotPermittedScreenStatusText className="not-permitted-screen__statusText">
        <FormattedMessage id={statusText} />
      </NotPermittedScreenStatusText>
      <NotPermittedScreenIcon className="not-permitted-screen__icon">
        <img src={icon} alt="icon" />
      </NotPermittedScreenIcon>
      <NotPermittedScreenMessage className="not-permitted-screen__message_description">
        <FormattedMessage id={description} />
      </NotPermittedScreenMessage>
    </NotPermittedScreenWrapper>
  </NotPermittedScreenContainer>
));

export default NotPermittedScreen;
